import "./SliderSwitch.css";

interface Props {
  defaultValue: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}

const SliderSwitch = ({ defaultValue, onChange }: Props) => {
  return (
    <>
      <label className="switch">
        <input type="checkbox" defaultChecked={defaultValue} onChange={onChange} />
        <span className="slider"></span>
      </label>
    </>
  );
};

export default SliderSwitch;
